"use client";

import { useTranslations } from "next-intl";

import { updatePreset } from "../state/actions";
import { useSoundboard } from "../state/reducer";
import { DownloadPresetButton } from "./DownloadPresetSoundsButton";
import { Input } from "./Input";
import { Panel } from "./Panel";
import { SaveFooter } from "./SaveFooter";

export const PresetEditor = ({ border = true }: { border?: boolean }) => {
  const t = useTranslations("ClientKeys.soundboard.preset_editor");
  const { state, dispatch } = useSoundboard();
  const presetId = state.panel?.data?.presetId as string | undefined;
  const preset = state.presets[presetId!];

  if (!preset || !presetId) {
    return null;
  }

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(
      updatePreset({
        id: presetId,
        name: e.target.value,
        icon: preset.icon,
      }),
    );
  };

  return (
    <Panel border={border} footer={<SaveFooter preset={preset} />} subtitle={preset.name} title={t("title")}>
      <div className='flex h-full flex-col justify-between gap-16'>
        <Input
          label={t("name_label")}
          onChange={handleNameChange}
          placeholder={t("name_placeholder")}
          value={preset.name}
        />
        <div className='w-full'>
          <DownloadPresetButton full={false} variant='inverse' />
        </div>
      </div>
    </Panel>
  );
};
